import { Api } from 'api';
import { callApi } from 'root/appSaga';
import { takeEvery, put, all } from 'redux-saga/effects';
import * as feedbackActions from 'features/support/feedbackActions';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as Sentry from '@sentry/react';
import { ModalEnum } from 'myParkdUtils/enums';
import {
    CONTENT_SEND_FEEDBACK_TO_SUPPORT_SUCCESS_MODAL,
    CONTENT_SEND_MESSAGE_TO_SUPPORT_SUCCESS_MODAL,
} from 'myParkdUtils/basicMessageModalContent';
import { SagaGenerator } from 'types';

export function* feedbackSaga(): SagaGenerator {
    return yield all([
        takeEvery(feedbackActions.SEND_MESSAGE_TO_SUPPORT_START, sendMessageToSupport),
        takeEvery(feedbackActions.SEND_FEEDBACK_TO_SUPPORT_START, sendFeedbackToSupport),
    ]);
}

export function* sendFeedbackToSupport(params: ReturnType<typeof feedbackActions.sendFeedbackToSupport>) {
    const message = params.payload.message;
    const starRatingData = params.payload.starRatingData;
    const feedback = starRatingData ? starRatingData + `\nfeedback: ${message}` : message;
    try {
        yield callApi(Api.sendMessageToSupport, { description: feedback });
        yield put(feedbackActions.sendFeedbackToSupportCompleted(starRatingData));
        yield put(
            modalWindowActions.updateModalWindow(ModalEnum.BASIC_MESSAGE_MODAL, {
                modalContent: CONTENT_SEND_FEEDBACK_TO_SUPPORT_SUCCESS_MODAL,
            })
        );
    } catch (error) {
        console.error(error);
        Sentry.captureException(error);
        yield put(feedbackActions.sendFeedbackToSupportError(error));
        yield put(modalWindowActions.updateModalWindow(ModalEnum.SOMETHING_WENT_WRONG));
    }
}

export function* sendMessageToSupport(params: ReturnType<typeof feedbackActions.sendMessageToSupport>) {
    const { message } = params.payload;
    try {
        yield callApi(Api.sendMessageToSupport, { description: message });
        yield put(feedbackActions.sendMessageToSupportCompleted());
        yield put(
            modalWindowActions.updateModalWindow(ModalEnum.BASIC_MESSAGE_MODAL, {
                modalContent: CONTENT_SEND_MESSAGE_TO_SUPPORT_SUCCESS_MODAL,
            })
        );
    } catch (error) {
        console.error(error);
        Sentry.captureException(error);
        yield put(feedbackActions.sendMessageToSupportError(error));
        yield put(modalWindowActions.updateModalWindow(ModalEnum.SOMETHING_WENT_WRONG));
    }
}
